import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "export-detail" }
const _hoisted_2 = { class: "export-detail__label" }

export interface Props {
    label: string
    value: string
    isValueLargeSize?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportDetail',
  props: {
    label: null,
    value: null,
    isValueLargeSize: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { label: string, value: string, isValueLargeSize: boolean };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.label), 1),
    _createElementVNode("div", {
      class: _normalizeClass([{ 'export-detail__value--large': __props.isValueLargeSize }, "export-detail__value"])
    }, _toDisplayString(__props.value), 3)
  ]))
}
}

})